import React from "react";

import User from "views/admin/Users/User";

const UserAccount = () => {
    return <User isProfileSite />;
};

export default UserAccount;
